import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export enum LicenceState {
  ASSIGNED = 'assigned',
  FREE = 'free',
  ENDING = 'ending',
  HALF_STATE = 'half_state',
}

export enum LicenceHolder {
  USER = 'user',
  DEVICE = 'device',
  NONE = 'none',
}

export const LICENCE_STATE_LABEL: Readonly<Record<string, string>> = {
  [LicenceState.ASSIGNED]: 'backoffice.enums.licence_state.assigned',
  [LicenceState.FREE]: 'backoffice.enums.licence_state.free',
  [LicenceState.ENDING]: 'backoffice.enums.licence_state.ending',
  [LicenceState.HALF_STATE]: 'backoffice.enums.licence_state.half_state',
};

export const LICENCE_STATE_TONE: Readonly<Record<string, StatusTone>> = {
  [LicenceState.ASSIGNED]: 'positive',
  [LicenceState.FREE]: 'neutral',
  [LicenceState.ENDING]: 'warning',
  [LicenceState.HALF_STATE]: 'danger',
};

export const LICENCE_HOLDER_LABEL: Readonly<Record<string, string>> = {
  [LicenceHolder.USER]: 'backoffice.enums.licence_holder.user',
  [LicenceHolder.DEVICE]: 'backoffice.enums.licence_holder.device',
  [LicenceHolder.NONE]: 'backoffice.enums.licence_holder.none',
};
